(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4820],{

/***/ 12674:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(93643);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_error__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rollbar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57662);
/* harmony import */ var rollbar__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(rollbar__WEBPACK_IMPORTED_MODULE_2__);
/* provided dependency */ var process = __webpack_require__(34155);



function Error(param) {
    let { statusCode  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_error__WEBPACK_IMPORTED_MODULE_1___default()), {
        statusCode: statusCode
    });
}
Error.getInitialProps = (param)=>{
    let { req , res , err  } = param;
    const statusCode = (res === null || res === void 0 ? void 0 : res.statusCode) || (err === null || err === void 0 ? void 0 : err.statusCode) || 404;
    // Only require Rollbar and report error if we're on the server
    if ( true && err && statusCode !== 404) {
        const rollbar = new (rollbar__WEBPACK_IMPORTED_MODULE_2___default())({
            accessToken: process.env.ROLLBAR_SERVER_TOKEN,
            environment:  true ? "production" : 0,
            nodeSourceMaps: true
        });
        rollbar.error(err, req, (rollbarError)=>{
            if (rollbarError) {
                // eslint-disable-next-line no-console
                console.error("[rollbar] error occurred while reporting", rollbarError);
            } else {
                ;
            }
        });
    }
    return {
        statusCode
    };
};
/* harmony default export */ __webpack_exports__["default"] = (Error);


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(97345)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(12674); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);